export default __webpack_public_path__ + "static/char-48-36710425b4610a826d1ff98cf6c592a8.webp";